import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { createSelector } from 'reselect'
import { getGroupedBundledPackages } from 'lib/bundleAndSave/getGroupedBundledPackages'

export const getBundledPackages = createSelector(
  (state: OfferPageState) => state.bundleOffer,
  (state: OfferPageState) => state.bundledOffers,
  (bundleOffer, bundledOffers) => {
    if (bundleOffer && bundledOffers) {
      // @ts-ignore TODO: What to do if bOffer.offer or bOffer.duration are undefined?
      return getGroupedBundledPackages(bundleOffer, Object.values(bundledOffers).map((bOffer) => ({
        offerId: bOffer.offer?.id,
        duration: bOffer.duration,
      })))
    }

    return null
  },
)
